export default "__VITE_ASSET__DZyzP1yj__"